import dayjs from 'dayjs';

const multipleServicesStyle = {
    font: '#ffffff',
    border_color: '#3B82F6',
    Tooltip: 'This Service contains multiple services',
    background_color: '#1E3A8A',
    service_id: 99,
    service_type: 'Multiple'
};

export const transformServicesToEvents = (services, serviceInfos) => {
    let result = [];
    if (!services?.length) return result;

    services.forEach((item, index) => {
        if (!item.start_date) return;
        const staticServices = item?.static_services;
        const vehicle = item?.vehicles?.[0];
        const isMultiple = staticServices?.length > 1;

        // Determine the source for styling properties
        // VOOV2-2308: a service with no type (or a type no longer in settings) has no static_services;
        // it falls back to "No Type" below instead of breaking the whole calendar
        const styleSource = isMultiple ? multipleServicesStyle : staticServices?.[0];
        const completed = item.end_date !== null;
        const noTypeService = serviceInfos?.find((service) => service?.type === 'No Type');
        const bgcolor = noTypeService?.backgroundColor || '#CCCCCC';
        const borderColor = noTypeService?.borderColor || '#EEEEEE';

        // --- Updated end date calculation ---
        let endDate;
        if (completed) {
            endDate = dayjs(item.end_date).local().format('YYYY-MM-DD');
        } else if (item.duration && item.durationChoice) {
            const start = dayjs(item.start_date).local();
            if (item.durationChoice === 'H') {
                endDate = start.add(item.duration, 'hour').format('YYYY-MM-DD');
            } else if (item.durationChoice === 'D') {
                endDate = start.add(item.duration, 'day').format('YYYY-MM-DD');
            } else {
                endDate = start.startOf('day').add(1, 'day').endOf('day').format('YYYY-MM-DD');
            }
        } else {
            endDate = dayjs(item.start_date).startOf('day').add(1, 'day').endOf('day').local().format('YYYY-MM-DD');
        }
        // --- End update ---

        result.push({
            id: index,
            backColor: styleSource ? styleSource.background_color : bgcolor,
            borderColor: styleSource ? styleSource.border_color : borderColor,
            serviceType: styleSource?.service_type || noTypeService?.type || 'No Type',
            duration: item?.duration,
            type: item?.service_type,
            serviceTypes: staticServices,
            serviceTypeIds: item?.service_type_ids ?? null,
            start: dayjs(item.start_date).local().format('YYYY-MM-DD'),
            end: endDate,
            isCompleted: completed,
            resource: item?.vehicle_ids ?? null,
            vehicleReg: vehicle?.vehicle_reg,
            vehicleId: vehicle?.vehicle_id,
            vehicleType: vehicle?.car_name,
            vehicleMake: vehicle?.vehicle_make,
            serviceId: item?.id ?? null,
            statusDetails: item?.status_details,
            status: item?.status_id?.slice(3)?.trim(),
            statusFull: item?.status_id,
            service: item?.service_details,
            supplier: item?.supplier_name,
            isScheduled: Boolean(item?.service_scheduled),
            taskDescription: item?.task_description,
            failDescription: item?.fail_description,
            locationType: item?.location_txt,
            workTicketId: item?.work_ticket_id,
            statutory: item?.statutory,
            severity: item?.severity,
            roadworthy: item?.roadworthy,
            intervalValue: item?.interval_value,
            intervalUnit: item?.interval_unit,
            locationId: item?.location_id,
            reportedBy: item?.reported_by,
            reportedDate: item?.reported_date,
            reportedWhere: item?.reported_where,
            managerId: item?.manager_id,
            odometerReadings: item?.odometer_readings,
            supplierId: item?.supplier_id,
            supplierLocation: item?.supplier_location,
            updatedBy: item?.updated_by,
            ticketTemplate: item?.ticket_template,
            totalMinutes: item?.total_minutes,
            autoScheduled: item?.auto_schedule && typeof item.auto_schedule === 'object' && Object.keys(item.auto_schedule).length > 0,
            related_services: item?.auto_schedule?.related_services,
            recordType: item?.record_type
        });
    });
    return result;
};
